<template>
<div class="chapter">
<div class="inner_page">
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// the-beach-at-night_00001.vue?bbca6a36